var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluetick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "url(#paint0_linear_4260_13188)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41219 11.9678C6.25093 12.1291 5.98946 12.1291 5.8282 11.9678L3.6202 9.7598C3.38824 9.52784 3.38824 9.15176 3.6202 8.9198C3.85216 8.68784 4.22824 8.68784 4.46019 8.9198L6.12019 10.5798L10.9802 5.7198C11.2122 5.48785 11.5882 5.48785 11.8202 5.7198C12.0522 5.95176 12.0522 6.32784 11.8202 6.5598L6.41219 11.9678Z",
    fill: "#E0F8F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4260_13188",
    x1: 14.75,
    y1: 14,
    x2: 1.75,
    y2: 2.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetick);
export default __webpack_public_path__ + "static/media/bluetick.467b3a64b96b538c39361a0e0fc01456.svg";
export { ForwardRef as ReactComponent };